export const WITH_INTERNAL_METRICS = process.env.REACT_APP_WITH_INTERNAL_METRICS === 'true';
export const WITH_CUSTOM_DASHBOARDS = process.env.REACT_APP_WITH_CUSTOM_DASHBOARDS === 'true';
